import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.map.js";
export function setHelpState(state) {
  return {
    type: 'SET_HELP_STATE',
    state: state
  };
}
export function setHelpArticles(articles) {
  return {
    type: 'SET_HELP_ARTICLES',
    articles: articles
  };
}
export function setHelpActiveArticle(id) {
  return {
    type: 'SET_HELP_ACTIVE_ARTICLE',
    id: id
  };
}
export function addHelpArticles(articles) {
  return function (dispatch) {
    return Promise.resolve(articles).then(function (data) {
      return dispatch(setHelpArticles(data.map(function (item) {
        return {
          title: item.title,
          id: item.id,
          path: item.path,
          type: item.type,
          body: {
            url: item.url,
            text: item.body,
            metadata: null
          }
        };
      })));
    });
  };
}